import { Language } from '@styled-icons/material/Language';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Text,
  HStack,
  Link,
  Box,
  Divider,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

interface LanguageSwitcherProps {
  buttonTextColor: 'black' | 'white';
  optionTextColor: 'black' | 'white';
}

const LanguageSwitcher: React.VFC<LanguageSwitcherProps> = ({
  buttonTextColor,
  optionTextColor,
}) => {
  const { i18n } = useTranslation();
  const switchLang = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        color={buttonTextColor}
        p="1"
        rightIcon={<ChevronDownIcon />}
        variant="ghost"
      >
        <HStack>
          <Language className="icon" /> <Text textTransform="uppercase">{i18n.language}</Text>
        </HStack>
      </MenuButton>
      <MenuList color={optionTextColor}>
        <MenuItem onClick={() => switchLang('jp')}>日本語</MenuItem>
        <MenuItem onClick={() => switchLang('en')}>English</MenuItem>
      </MenuList>
    </Menu>
  );
};

export default LanguageSwitcher;
